export default __webpack_public_path__ + "static/media/btn_str_hart.67d5bde5.svg";